import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import { WarningPopUp, Image } from "hesus-ui-kit";
import ClipLoader from "react-spinners/ClipLoader";
import editIcon from "@icons/blue-edit.svg";
import deleteIcon from "@icons/ic-cancel.svg";

import {
  RowHeader,
  GridRow,
  GridItem,
  GridSubItem,
} from "../../SolutionAcceptanceView.styled";

const Header = (props) => {
  const {
    t,
    data,
    solutionId,
    setRefreshAcceptanceData,
    onSolutionEditAcceptanceClick,
    setAcceptanceIdForEdit,
  } = props;

  const [isConfirmVisible, setConfirmVisibility] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [isConfirm, setActionConfirmStatus] = useState(false);
  const [acceptanceId, setAcceptanceId] = useState("");

  const onAcceptanceDelete = (id) => {
    setAcceptanceId(id);
    setConfirmVisibility(true);
  };

  const onPopUpCancel = () => {
    setAcceptanceId("");
    setConfirmVisibility(false);
    setActionConfirmStatus(false);
  };

  const onPopUpConfirm = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(true);
  };

  useEffect(() => {
    if (isConfirm) {
      setLoading(true);
      axios
        .delete(`/solutions/${solutionId}/acceptances/${acceptanceId}`)
        .then(() => {
          setAcceptanceId("");
          setRefreshAcceptanceData(true);
          setLoading(false);
        })
        .catch((error) => {
          setRefreshAcceptanceData(false);
          setLoading(false);
          handleApiError(error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConfirm]);

  const onSolutionAddEditAcceptanceClick = (id) => {
    setAcceptanceIdForEdit(id);
    onSolutionEditAcceptanceClick();
  };

  return (
    <>
      <RowHeader
        borderRadius="5px 5px 0px 0px"
        backgroundColor={data?.isActive ? "#008395" : "#cccccc"}
      >
        <GridRow
          column="auto 1fr auto"
          marginTop="0px"
          marginBottom="0px"
          gridGap="0rem"
          padding="5px 10px"
        >
          <GridItem
            fontSize="16px"
            fontWeight="700"
            color="#fff"
            textAlign="left"
            leftRadius="5px"
          >
            {t("SOLUTION_ACCEPTANCE") + " #" + data?.number}
          </GridItem>
          <GridSubItem alignContent="center" textAlign="right">
            <Image
              src={editIcon}
              // onClick={() => onDisputeEdit(data?.id)}
              alt={t("SOLUTION_ACCEPTANCE_EDIT_TOOLTIP")}
              title={t("SOLUTION_ACCEPTANCE_EDIT_TOOLTIP")}
              className="solution-acceptance-view__action-icon"
              onClick={() => onSolutionAddEditAcceptanceClick(data.id)}
            />
            {!!data.isActive && !isLoading && (
              <Image
                src={deleteIcon}
                styles={{ marginLeft: "5px" }}
                className="solution-acceptance-view__action-icon"
                onClick={() => onAcceptanceDelete(data?.id)}
                alt={t("SOLUTION_ACCEPTANCE_DISABLE_TOOLTIP")}
                title={t("SOLUTION_ACCEPTANCE_DISABLE_TOOLTIP")}
              />
            )}

            {isLoading && <ClipLoader size={15} color="#fff" />}
          </GridSubItem>
        </GridRow>
      </RowHeader>

      {isConfirmVisible && (
        <WarningPopUp
          title={t("SOLUTION_ACCEPTANCE_CONFIRMATION_BOX_DELETE")}
          message={t("SOLUTION_ACCEPTANCE_CONFIRMATION_BOX_DELETE_CONTENT")}
          onPopUpCancel={onPopUpCancel}
          onPopUpConfirm={onPopUpConfirm}
          ValidateContent={t("YES")}
          CancelContent={t("CANCEL")}
        />
      )}
    </>
  );
};

Header.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(Header);
